import React from "react";
import { education, careerHighlights, awards, volunteering } from "../mock";
import { SectionBanner } from "./About";
import { GraduationCap, Trophy, Briefcase, HandHeart, ArrowUpRight } from "lucide-react";

const Resume = () => {
  return (
    <>
      {/* Career */}
      <SectionBanner title="Career" id="career" />
      <section className="bg-neutral-50">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="reveal grid gap-4">
            {careerHighlights.map((c, i) => (
              <div
                key={i}
                className="flex gap-4 items-start bg-white rounded-lg p-6 shadow-sm border border-neutral-100 hover:shadow-md transition-shadow"
              >
                <Briefcase className="text-lime-500 shrink-0 mt-0.5" size={22} />
                <p className="text-neutral-700 tracking-body leading-relaxed text-[15px]">
                  {c}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education */}
      <SectionBanner title="Education" id="education" />
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="relative border-l-2 border-lime-200 ml-3 md:ml-6">
            {education.map((e, i) => (
              <div key={i} className="reveal relative pl-8 md:pl-12 pb-10 last:pb-0">
                <span className="absolute -left-[9px] top-1 h-4 w-4 rounded-full bg-lime-500 ring-4 ring-lime-100" />
                <div className="flex items-center gap-2 text-lime-600 font-head font-semibold text-sm">
                  <GraduationCap size={16} /> {e.year}
                </div>
                <h3 className="mt-1 font-head font-semibold text-neutral-800 text-lg">
                  {e.title}
                </h3>
                <p className="text-neutral-500 tracking-body text-sm mt-0.5">
                  {e.org}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Awards */}
      <SectionBanner title="Awards" id="awards" />
      <section className="bg-neutral-50">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="reveal grid sm:grid-cols-2 gap-6">
            {awards.map((a, i) => (
              <div
                key={i}
                className="bg-white rounded-lg p-7 shadow-sm border border-neutral-100 hover:-translate-y-1 hover:shadow-md transition-all duration-200"
              >
                <div className="flex items-center justify-between">
                  <Trophy className="text-lime-500" size={24} />
                  <span className="font-head font-bold text-neutral-300 text-xl">
                    {a.year}
                  </span>
                </div>
                <h3 className="mt-4 font-head font-semibold text-neutral-800 text-lg leading-snug">
                  {a.title}
                </h3>
                <p className="mt-2 text-neutral-500 tracking-body text-sm leading-relaxed">
                  {a.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Volunteering */}
      <SectionBanner title="Volunteering" id="volunteering" />
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="reveal max-w-4xl">
            <div className="flex items-center gap-2 text-lime-600 font-head font-semibold text-sm">
              <HandHeart size={18} /> {volunteering.year}
            </div>
            <h3 className="mt-2 font-head font-bold text-neutral-800 text-2xl">
              {volunteering.org}
            </h3>
            <p className="mt-4 font-head font-medium text-neutral-700">
              {volunteering.role}
            </p>
            <p className="mt-5 text-neutral-600 tracking-body leading-relaxed text-[15px]">
              {volunteering.body}
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              {volunteering.links.map((l) => (
                <a
                  key={l.url}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-lime-600 hover:text-lime-700 font-head font-medium text-sm border-b border-transparent hover:border-lime-500 transition-colors"
                >
                  {l.label} <ArrowUpRight size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
